<div class="slideout-content">
  <!-- Modal to add new user starts-->
  <div
    class="modalsd modal-slide-in sdfade new-user-modal"
    id="modals-slide-in"
  >
    <div class="modal-dialog">
      <form
        class="add-new-user modal-content pt-0"
        (ngSubmit)="(newUserForm.form.valid)"
        #newUserForm="ngForm"
      >
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          (click)="toggleSidebar('new-user-sidebar')"
        >
          ×
        </button>
        <div class="modal-header mb-1">
          <h5 class="modal-title" id="exampleModalLabel">New User</h5>
        </div>

        <div class="modal-body flex-grow-1">
          <div class="row">
            <div class="form-group col-6">
              <label class="form-label" for="new-user-sidebar-firstname"
                >First Name</label
              >
              <input
                type="text"
                class="form-control dt-first-name"
                id="new-user-sidebar-firstname"
                placeholder="John"
                name="user-firstname"
                [(ngModel)]="currentUser.firstName"
                [class.error]="newUserForm.submitted && FFirstNameRef.invalid"
                #FFirstNameRef="ngModel"
                required
                aria-label="John"
                aria-describedby="new-user-sidebar-firstname2"
              />
              <span
                *ngIf="newUserForm.submitted && FFirstNameRef.invalid"
                class="invalid-form"
              >
                <small
                  class="form-text text-danger"
                  *ngIf="FFirstNameRef.errors.required"
                  >This field is required!</small
                >
              </span>
            </div>
            <div class="form-group col-6">
              <label class="form-label" for="new-user-sidebar-lastname"
                >Last Name</label
              >
              <input
                type="text"
                id="new-user-sidebar-lastname"
                class="form-control dt-lastname"
                placeholder="Doe"
                aria-label="Doe"
                aria-describedby="new-user-sidebar-lastname2"
                name="user-lastname"
                [(ngModel)]="currentUser.lastName"
                [class.error]="newUserForm.submitted && FLastNameRef.invalid"
                #FLastNameRef="ngModel"
                required
              />
              <span
                *ngIf="newUserForm.submitted && FLastNameRef.invalid"
                class="invalid-form"
              >
                <small
                  class="form-text text-danger"
                  *ngIf="FLastNameRef.errors.required"
                  >This field is required!</small
                >
              </span>
            </div>
          </div>
          <div class="form-group">
            <label class="form-label" for="new-user-sidebar-email"
              >Email</label
            >
            <input
              type="text"
              id="new-user-sidebar-email"
              class="form-control dt-email"
              placeholder="john.doe@example.com"
              aria-label="john.doe@example.com"
              aria-describedby="new-user-sidebar-email2"
              name="user-email"
              [(ngModel)]="currentUser.email"
              [class.error]="newUserForm.submitted && FEmailRef.invalid"
              #FEmailRef="ngModel"
              required
            />
            <span
              *ngIf="newUserForm.submitted && FEmailRef.invalid"
              class="invalid-form"
            >
              <small
                class="form-text text-danger"
                *ngIf="FEmailRef.errors.required"
                >This field is required!</small
              >
            </span>
          </div>
          <div class="form-group">
            <label class="form-label" for="new-user-sidebar-user-role">User Role</label>
            <select
              id="new-user-sidebar-user-role"
              name="new-user-sidebar-user-role"
              class="form-control"
              [(ngModel)]="currentUser.role"
              [ngModelOptions]="{ standalone: true }"
            >
              <option
                *ngFor="
                  let role of data.accountSetting.config.userRoles;
                  let i = index
                "
                [value]="role"
              >
                {{ role }}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label>Locations</label>
            <!-- Select Multi with Icon -->
            <ng-select
              [items]="locations"
              [multiple]="true"
              [closeOnSelect]="false"
              bindLabel="name"
              bindValue="id"
              name="user-locations"
              [(ngModel)]="currentUser.userLocations"
            >
              <ng-template ng-label-tmp let-item="item" let-clear="clear">
                <span class="ng-value-label">
                  <img
                    *ngIf="item.locationLogo == ''"
                    src="../../../../../assets/images/profile/user-uploads/location-00.png"
                    width="20px"
                    height="20px"
                  />
                  <img
                    *ngIf="item.locationLogo != ''"
                    [src]="item.locationLogo"
                    width="20px"
                    height="20px"
                  />
                  {{ item.locationName }}
                </span>
                <span
                  class="ng-value-icon right"
                  (click)="clear(item)"
                  aria-hidden="true"
                  >×</span
                >
              </ng-template>

              <ng-template ng-header-tmp>
                <a (click)="selectAll()" class="btn btn-flat-primary btn-sm">
                  Select all
                </a>
                <a (click)="unselectAll()" class="btn btn-flat-primary btn-sm">
                  Unselect all
                </a>
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                  <img
                    *ngIf="item.locationLogo == ''"
                    src="../../../../../assets/images/profile/user-uploads/location-00.png"
                    width="20px"
                    height="20px"
                  />
                  <img
                    *ngIf="item.locationLogo != ''"
                    [src]="item.locationLogo"
                    width="20px"
                    height="20px"
                  />
                  {{ item.locationName }}
                </ng-template>
            </ng-select>
            <!--/ Select Multi with Icon -->
          </div>

          <div class="col-12" *ngIf="!loadingButton">
            <button
              type="submit"
              class="btn btn-primary mr-1"
              (click)="submit(newUserForm)"
              rippleEffect
            >
              Create
            </button>
            <button
              type="reset"
              class="btn btn-outline-secondary"
              (click)="toggleSidebar('new-user-sidebar')"
            >
              Cancel
            </button>
          </div>
          <div class="col-12" *ngIf="loadingButton">
            <button
              class="btn btn-outline-primary"
              type="button"
              disabled
              rippleEffect
            >
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
              <span class="ml-25 align-middle">Saving...</span>
            </button>
          </div>
          <!-- <div *ngIf="!alertClose" style="padding: 12px;">
            
            <ngb-alert [type]="'danger'" (closed)="alertClose = !alertClose">
              <h4 class="alert-heading">Error</h4>
              <div class="alert-body">
                {{alert}}
                <button type="button" class="close" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </ngb-alert>
          </div> -->
        </div>
      </form>
    </div>
  </div>
  <!-- Modal to add new user Ends-->
</div>
